module.exports = __webpack_public_path__ + "static/images/04450673fc8369a817e7b8c3c05251a3.svg";